import React from "react";

const Cargo = ({ config, renderField, renderSelect, i, remove, modal, canUseMultipleBidCargos }) => {
    const { name, typeId, comment, packType, placesCount, weight, volume, length, width, height } = config;
    const isFirstItem = i === 0;
    const removeCargo = () => {
        return modal({
            name: "confirm",
            title: "Удаление груза",
            text: "Вы уверены, что хотите удалить груз?",
            action: () => remove(i),
        });
    };

    return (
        <>
            {canUseMultipleBidCargos && (
                <div className="book-form__section-head book-form__section-head--closable book-form__section-head--cargo">
                    {!isFirstItem && (
                        <div className="book-form__section-close close" onClick={removeCargo} title="Удалить груз" />
                    )}
                    <div className="form-group">
                        <strong>#{i + 1} Груз</strong>
                    </div>
                </div>
            )}
            {!canUseMultipleBidCargos && (
                <div className="form-group">
                    <strong>Груз</strong>
                </div>
            )}
            {renderField({ ...name, fieldWrapper: "col-sm-8 col-md-5" })}
            {renderSelect({ ...typeId, fieldWrapper: "col-sm-8 col-md-5" })}
            {renderField({ ...packType, fieldWrapper: "col-sm-8 col-md-5" })}
            {renderField({ ...placesCount, fieldWrapper: "col-sm-8 col-md-5" })}
            {renderField({ ...comment, fieldWrapper: "col-sm-8 col-md-5" })}
            {renderField({ ...weight, fieldWrapper: "col-sm-8 col-md-5" })}
            {renderField({ ...volume, fieldWrapper: "col-sm-8 col-md-5" })}
            {renderField({ ...length, fieldWrapper: "col-sm-8 col-md-5" })}
            {renderField({ ...width, fieldWrapper: "col-sm-8 col-md-5" })}
            {renderField({ ...height, fieldWrapper: "col-sm-8 col-md-5" })}
        </>
    );
};

export default Cargo;
